import React, { PureComponent } from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'
import Icon from 'aria-viewer/tour/components/icon'
import VideoVolumeBar from '../bars/simpleVideoVolumeBar'
import { VIDEO_VOLUME_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

class VideoVolumeButton extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            volume: 1,
        }
        this.volumeHeight = this.props.volumeHeight || 140 * (window.innerHeight / 854)
    }

    static defaultProps = { volumeFadeOutTime: 2000 }

    handleOnClick = e => {
        const { onClick, player } = this.props

        e && e.stopPropagation && e.stopPropagation()
        e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation()
        e && e.preventDefault && e.preventDefault()

        onClick && onClick(e)
        // if (videoVolume === 0) {
        //     setVideoVolume(100)
        // } else {
        //     setVideoVolume(0)
        // }
        player.getVolume(v => {
            if (v === 0) {
                player.setVolume(1)
                this.setState({
                    volume: 1,
                })
            } else {
                player.setVolume(0)
                this.setState({
                    volume: 0,
                })
            }
        })
    }

    registerProps = ({ setVideoVolume, videoVolume }) => {
        if (this.props.videoVolume != videoVolume) {
            setVideoVolume(videoVolume)
        }
    }

    componentWillReceiveProps(newProps) {
        this.registerProps(newProps)
    }

    toggleVolumeBar = e => {
        const { onChange, toggleVideoVolumeBarVisibility } = this.props
        onChange && onChange(e)

        toggleVideoVolumeBarVisibility && toggleVideoVolumeBarVisibility()
    }

    handleChange = e => {
        const { onChange } = this.props
        onChange && onChange()
    }

    render() {
        const { volume } = this.state
        const { volumeFadeOutTime, videoVolume, isVolumeBarVisible, children, theme, style, player } = this.props

        return (
            <Button
                onClick={this.handleOnClick}
                tabIndex={VIDEO_VOLUME_BUTTON_INDEX}
                handleOnMouseOver={this.toggleVolumeBar}
                onMouseOut={this.toggleVolumeBar}
                theme="video_button"
                style={style}
            >
                <Icon icon={videoVolume === 0 ? 'volumeOff' : 'volumeOn'} />
                {children}
                {/* <OpacityHelper test={isVolumeBarVisible}> */}
                <VideoVolumeBar
                    onChange={this.handleChange}
                    player={player}
                    style={{
                        position: 'relative',
                        bottom: this.volumeHeight + 80,
                        right: '7px',
                    }}
                    volumeFadeOutTime={volumeFadeOutTime}
                    theme={theme}
                    volumeHeight={this.volumeHeight}
                    volume={volume}
                />
                {/* </OpacityHelper> */}
            </Button>
        )
    }
}

export default VideoVolumeButton
